/**
 * @function Theme
 * @params {jsx} children
 * @returns theme of an applicaion.
 */

import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";

interface Props {
  children: React.JSX.Element | React.JSX.Element[];
}

function Theme({ children }: Props) {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#E9522A",
        contrastText: "white"
      }
    },
    typography: {
      button: {
        fontFamily: "Montserrat",
        letterSpacing: "0.025em",
        textTransform: "none",
        fontSize: "1rem",
        fontWeight: "600"
      }
    }
  });

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default Theme;
